/**
 * 在这里添加页面路由名称
 * 作用于keepAlive设置缓存
 */

export default {
    home: 'home',
    login: 'login',
    goodsDetail: 'goodsDetail',
    pageNotFound: 'pageNotFound',
    photoReports: 'photoReports',
    specialActivity: 'specialActivity',
    marketingDetail: 'marketingDetail',
    storeList: 'storeList',
    goodsList: 'goodsList',
    confirmOrder: 'confirmOrder',
    editOrderInfo: 'editOrderInfo',
    editAddress: 'editAddress',
    chooseToPay: 'chooseToPay',
    payResult: 'payResult',
    user: 'user',
    bindingPhone: 'bindingPhone',
    bindingResult: 'bindingResult',
    seckill: 'seckill',
    seckillStoreList: 'seckillStoreList',
    distributionDetail: 'distributionDetail',
    distributionStoreList: 'distributionStoreList',
    advice: 'advice',
    changeGoods: 'changeGoods',
    selectService: 'selectService',
    serviceDetail: 'serviceDetail',
    mergeSpread: 'mergeSpread',
    mergeSpreadStoreList: 'mergeSpreadStoreList',
    activityPayResult: 'activityPayResult',
    marketingActivities: 'MarketingActivities',
    marketingConfirmOrder: 'MarketingConfirmOrder',
    discountService: 'discountService',
    recommendStoreList: 'recommendStoreList',
    storeHome: 'storeHome',
    distributorMall: 'distributorMall',
    distributionList: 'distributionList',
    goodsClassification: 'goodsClassification',
    carBrandSelect: 'carBrandSelect',
    carLineSelect: 'carLineSelect',
    carModelSelect: 'carModelSelect',
    customDetail: 'customDetail',
    customSingularDetail: 'customSingularDetail',
    customGoodsList: 'customGoodsList',
    customSingularGoodsList: 'customSingularGoodsList',
    regularCustomDetail: 'regularCustomDetail',
    paction: 'paction',
    selectAddress: 'selectAddress',
    selectCityList: 'selectCityList',
    moreSstoreGoodsDetail: 'moreSstoreGoodsDetail',
    couponDetail: 'couponDetail',
    couponStoreList: 'couponStoreList',
    aggregation: 'aggregation',
    aggregationSearch: 'aggregationSearch',
    customSingularStoreList: 'customSingularStoreList',
}
